import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../guards/auth-guard.service';
import {SocialPageComponent} from './social-page.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.googleSignUp.pageInRouting,
    data: {data: PAGES_AND_PATHS.googleSignUp},
    component: SocialPageComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./social-page.module').then(m => m.SocialPageModule)
  },
  {
    path: PAGES_AND_PATHS.appleSignUp.pageInRouting,
    data: {data: PAGES_AND_PATHS.appleSignUp},
    component: SocialPageComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./social-page.module').then(m => m.SocialPageModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SocialPageRoutingModule { }
